<div class="condition-types">
    <div class="title">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.condition-types.title"></sc-dictionary-label>
    </div>

    <div class="filter-type-groups">
        <div class="filter-type-group" *ngFor="let group of conditionGroups">
            <div class="group-title">
              <sc-dictionary-label [dictionaryKey]="group.nameDictionaryKey"></sc-dictionary-label>
            </div>
            <div class="filter-type" *ngFor="let type of group.types">
                <div class="drag-handle" draggable="true" (dragstart)="onDragTypeStart($event, type)"
                    (dragend)="onDragTypeEnd($event)">
                    <div aria-hidden="false">
                        <sc-icon iconClass="fa-bars"></sc-icon>
                    </div>
                </div>
                <div class="type-label">
                  <sc-dictionary-label [dictionaryKey]="type.nameDictionaryKey"></sc-dictionary-label>
                </div>
            </div>
        </div>
    </div>

</div>
